import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { IntlProvider as IntlNextProvider, injectIntl } from 'react-intl-next';
import { DEFAULT_LOCALE, lazyLoadTranslations, useLocale } from '@atlassian/embedded-confluence-common';
var I18nProviderInner = function I18nProviderInner(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    updateMessages = _useState2[1];
  var _useLocale = useLocale(props),
    locale = _useLocale.locale;
  useEffect(function () {
    function loadTranslations() {
      return _loadTranslations.apply(this, arguments);
    }
    function _loadTranslations() {
      _loadTranslations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$lazyLoadTransl, newMessages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return lazyLoadTranslations(locale);
            case 2:
              _yield$lazyLoadTransl = _context.sent;
              newMessages = _yield$lazyLoadTransl.default;
              updateMessages(newMessages);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _loadTranslations.apply(this, arguments);
    }
    void loadTranslations();
  }, [locale]);
  return /*#__PURE__*/React.createElement(IntlNextProvider, {
    locale: locale,
    messages: messages,
    defaultLocale: DEFAULT_LOCALE
  }, props.children);
};
export var I18nProvider = injectIntl(I18nProviderInner, {
  enforceContext: false
});